export const COLOR = {
    DEEP_BLUE: '#111112',
    GRAY: '#021834',
    PURPLE: '#7A4183',
    BLACK: '#000',
    WHITE: '#fff'
}